import { FC, useEffect, useState } from "react";
import imageSuccess from "../../assets/images/mesaFoodComplete.png";
import {
  calculatePriceFractionalToProduct,
  floatToPrice,
} from "../../functions/price_functions";
import {
  CustomerType,
  OrderAddress,
  OrderType,
} from "../../contexts/OrderContext";
import { ConfigType } from "../../contexts/AppConfigContext";
import { useOrder } from "../../hooks/useOrder";
import { useAppConfig } from "../../hooks/useAppConfig";
import { useProduct } from "../../hooks/useProduct";
import { ImageLazy } from "../../components/ImageLazy";
import { Input } from "../../components/inputs/inputs";
import styles from "./styles.module.css";
import { usePluginspace } from "../../hooks/usePluginspace";
import { cepToMask } from "../../functions/mask";
import api from "../../services/api";
import { Loading } from "../../components/Loading";
import { useNavigate, useParams } from "react-router-dom";
import { useFoodConfig } from "../../hooks/useFood";
import { useToast } from "../../hooks/useToast";
import ReactLoading from "react-loading";
import Swal from "sweetalert2";
import usePreventNavigation from "../../components/PreventBackNavigation/PreventBackNavigation";

const SuccessOrderFood: FC<any> = () => {
  const { synchronizeContextToStorage } = useOrder();

  const { getAppConfig } = useAppConfig();

  const [loading, setLoading] = useState(true);
  const [config, setConfig] = useState<ConfigType | void>();
  const { getToken } = usePluginspace();
  const navigate = useNavigate();

  const [showErroNotaFiscal, setShowErroNotaFiscal] = useState(false);
  const [showNotaFiscal, setShowNotaFiscal] = useState(false);
  const [successNotaFiscal, setSuccessNotaFiscal] = useState(false);
  const [notaFiscalXml, setNotaFiscalXml] = useState("");
  const [products, setProducts] = useState([]);
  const {
    getOrderDataNFiscal,
    isCard,
    isTable,
    cardNumber,
    tableNumber,
    tableName,
    cardName,
  } = useFoodConfig();

  const [isCounter, setIsCounter] = useState<boolean>(false);
  const [order, setOrder] = useState<any>();
  const [dataToNEF, setDataToNFE] = useState({
    aggregateId: ``,
    hostName: ``,
  });

  async function loadOrder(config: ConfigType) {
    await synchronizeContextToStorage();

    const products = localStorage.getItem("productsString");

    if (products) {
      setProducts(JSON.parse(products));
    }

    await gerarNotaFiscal(config);
  }

  async function getOrderFromCounter(orderIdExternal: string) {
    try {
      return await api
        .post(
          `/api/orders/filter?take=10&skip=${0}&page=${1}&order=DESC`,
          {
            orderidExt: orderIdExternal,
          },
          {
            headers: {
              Authorization: `Bearer ${await getToken()}`,
            },
          }
        )
        .then((response: any) => {
          if (response.data) {
            const order = response.data.data[0];
            let orderExt = order.content.externalCodeERP;

            if (!orderExt) {
              orderExt = order.orderidExt;
            }

            setOrder(orderExt);
            return orderExt;
          }
        })
        .catch((error: any) => {
          return "0";
        });
    } catch (error) {
      return "0";
    }
  }

  async function gerarNotaFiscal(config: ConfigType) {
    try {
      const orderFiscal = await getOrderDataNFiscal();
      let orderId = orderFiscal?.orderId;
      if (orderFiscal?.orderType === "counter") {
        setIsCounter(true);
        orderId = await getOrderFromCounter(orderFiscal?.orderId);
      }

      if (config && config.content.pdv.allowEmitNFE) {
        await api
          .post(
            "/api/order-food/finish_order_food",
            {
              orderType: orderFiscal?.orderType,
              orderId:
                orderFiscal?.orderType === "counter"
                  ? orderId
                  : orderFiscal?.orderId,
              number: orderFiscal?.number ? orderFiscal?.number : "",
            },
            {
              headers: {
                Authorization: `Bearer ${await getToken()}`,
              },
            }
          )
          .then((response: any) => {
            if (response.data) {
              const { aggregateId, hostName } = response.data.data;

              setDataToNFE({
                aggregateId,
                hostName,
              });
              setSuccessNotaFiscal(true);
              setShowNotaFiscal(true);
            }
          })
          .catch((error: any) => {
            if (error.response.data) {
              const { msg, success } = error.response.data;

              if (msg && msg === "Nota fiscal não foi recuperada") {
                setSuccessNotaFiscal(false);
                setShowNotaFiscal(true);

                return;
              }

              setShowErroNotaFiscal(true);
              return;
            }
          });
      }
    } catch (error) {
      console.log(error);
    }
  }

  async function getConfig() {
    setLoading(true);
    const config = await getAppConfig();
    setConfig(config);
    await loadOrder(config!);
    setLoading(false);
  }

  useEffect(() => {
    getConfig();
  }, []);

  useEffect(() => {
    navigate(window.location.pathname, { replace: true });
  }, []);

  const { pluginspace_id } = useParams();

  function getRouter() {
    try {
      // Helper function to safely encode base64
      const safeBtoa = (str: string | number): string => {
        try {
          return window.btoa(String(str));
        } catch (error) {
          console.warn("Erro ao codificar base64:", error);
          return ""; // Fallback para string vazia
        }
      };

      if (isCounter) {
        const encodedBalcao = safeBtoa("Balcão");
        return `/${pluginspace_id}/counter/${encodedBalcao}`;
      }

      if (isCard) {
        const encodedCardNumber = safeBtoa(cardNumber?.toString() || "");
        const encodedCardName = cardName ? cardName : "";

        if (!encodedCardNumber) {
          console.warn("Número da comanda inválido, redirecionando para produtos");
          return getDefaultRoute();
        }

        return `/${pluginspace_id}/card/${encodedCardNumber}/${encodedCardName}`;
      }

      if (isTable) {
        const encodedTableNumber = safeBtoa(tableNumber?.toString() || "");
        const encodedTableName = tableName ? tableName : "";

        if (!encodedTableNumber) {
          console.warn("Número da mesa inválido, redirecionando para produtos");
          return getDefaultRoute();
        }

        return `/${pluginspace_id}/table/${encodedTableNumber}/${encodedTableName}`;
      }

      return getDefaultRoute();
    } catch (error) {
      console.error("Erro geral na função getRouter:", error);
      return getDefaultRoute();
    }
  }

  function getDefaultRoute() {
    try {
      if (config?.content?.pdv?.showLayout === "l2") {
        return `/${pluginspace_id}/products-new`;
      } else {
        return `/${pluginspace_id}/products`;
      }
    } catch (error) {
      console.warn("Erro ao acessar configuração, usando rota padrão");
      return `/${pluginspace_id}/products`;
    }
  }

  usePreventNavigation(getRouter());

  // Helper function to safely encode base64
  const safeBtoa = (str: string | number): string => {
    try {
      return window.btoa(String(str));
    } catch (error) {
      console.warn("Erro ao codificar base64:", error);
      return ""; // Fallback para string vazia
    }
  };

  // Helper function to safely navigate
  const safeNavigate = (path: string, options?: any) => {
    try {
      navigate(path, options);
    } catch (error) {
      console.error("Erro ao navegar:", error);
      // Fallback: tenta navegar para página de produtos
      try {
        navigate(`/${pluginspace_id}/products`, { replace: true });
      } catch (fallbackError) {
        console.error("Erro no fallback de navegação:", fallbackError);
        // Último recurso: recarregar a página
        window.location.href = `/${pluginspace_id}/products`;
      }
    }
  };

  function navigateToCard() {
    try {
      if (!cardNumber) {
        console.warn("Número da comanda não encontrado, redirecionando para produtos");
        safeNavigate(`/${pluginspace_id}/products`, { replace: true });
        return;
      }

      localStorage.clear();
      const encodedCardNumber = safeBtoa(cardNumber.toString());
      const encodedCardName = cardName || "";

      if (!encodedCardNumber) {
        console.warn("Falha ao codificar número da comanda, redirecionando para produtos");
        safeNavigate(`/${pluginspace_id}/products`, { replace: true });
        return;
      }

      safeNavigate(
        `/${pluginspace_id}/card/${encodedCardNumber}/${encodedCardName}`,
        { replace: true }
      );
    } catch (error) {
      console.error("Erro em navigateToCard:", error);
      safeNavigate(`/${pluginspace_id}/products`, { replace: true });
    }
  }

  function navigateToTable() {
    try {
      if (!tableNumber) {
        console.warn("Número da mesa não encontrado, redirecionando para produtos");
        safeNavigate(`/${pluginspace_id}/products`, { replace: true });
        return;
      }

      localStorage.clear();
      const encodedTableNumber = safeBtoa(tableNumber.toString());
      const encodedTableName = tableName || "";

      if (!encodedTableNumber) {
        console.warn("Falha ao codificar número da mesa, redirecionando para produtos");
        safeNavigate(`/${pluginspace_id}/products`, { replace: true });
        return;
      }

      safeNavigate(
        `/${pluginspace_id}/table/${encodedTableNumber}/${encodedTableName}`,
        { replace: true }
      );
    } catch (error) {
      console.error("Erro em navigateToTable:", error);
      safeNavigate(`/${pluginspace_id}/products`, { replace: true });
    }
  }

  function navigateToCounter() {
    try {
      localStorage.clear();
      const encodedBalcao = safeBtoa("Balcão");

      if (!encodedBalcao) {
        console.warn("Falha ao codificar 'Balcão', usando fallback");
        const fallbackUrl = `/${pluginspace_id}/counter/QmFsY8Ojbw%3D%3D`; // "Balcão" em base64
        window.history.replaceState(null, "", fallbackUrl);
        window.location.reload();
        return;
      }

      const newUrl = `/${pluginspace_id}/counter/${encodedBalcao}`;
      window.history.replaceState(null, "", newUrl);
      window.location.reload();
    } catch (error) {
      console.error("Erro em navigateToCounter:", error);
      // Fallback: navegar para produtos
      try {
        window.location.href = `/${pluginspace_id}/products`;
      } catch (fallbackError) {
        console.error("Erro no fallback de navegateToCounter:", fallbackError);
        window.location.reload();
      }
    }
  }

  function navigateToMenu() {
    try {
      const showSafeAlert = (callback: () => void) => {
        try {
          if (config?.content?.pdv?.safeMode) {
            Swal.fire({
              icon: "info",
              title: "Mesa/Comanda Fechada",
              text: "Sua mesa/comanda foi Fechada. Você será redirecionado para a tela inicial.",
              confirmButtonText: "Ok",
            }).then(() => {
              try {
                callback();
              } catch (error) {
                console.error("Erro no callback do Swal:", error);
                safeNavigate(`/${pluginspace_id}/products`, { replace: true });
              }
            }).catch((error) => {
              console.error("Erro no Swal:", error);
              callback(); // Executa o callback mesmo se o Swal falhar
            });
          } else {
            callback();
          }
        } catch (error) {
          console.error("Erro em showSafeAlert:", error);
          callback(); // Executa o callback em caso de erro
        }
      };

      switch (true) {
        case isCounter:
          navigateToCounter();
          break;
        case isCard:
          showSafeAlert(() => navigateToCard());
          break;
        case isTable:
          showSafeAlert(() => navigateToTable());
          break;
        default:
          console.warn("Nenhuma condição de navegação atendida, redirecionando para produtos");
          safeNavigate(`/${pluginspace_id}/products`, { replace: true });
          break;
      }
    } catch (error) {
      console.error("Erro geral em navigateToMenu:", error);
      safeNavigate(`/${pluginspace_id}/products`, { replace: true });
    }
  }

  useEffect(() => {
    // Adiciona um novo estado no histórico atual
    window.history.pushState(null, "", window.location.href);
    console.log("Estado inicial adicionado ao histórico");

    const bloquearVoltar = () => {
      // Reinsere a URL atual para bloquear voltar
      window.history.pushState(null, "", window.location.href);
      console.log("Evento de voltar bloqueado");
    };

    // Escuta eventos de voltar
    window.addEventListener("popstate", bloquearVoltar);
    console.log("Listener de popstate adicionado");

    // Remove o listener ao desmontar o componente
    return () => {
      window.removeEventListener("popstate", bloquearVoltar);
      console.log("Listener de popstate removido");
    };
  }, []);

  return (
    <div className={styles.page}>
      <div
        className={styles.content}
        style={{
          padding: loading ? "0px" : "16px",
        }}
      >
        {loading ? (
          <div style={{ width: "100%", height: "calc(100vh)" }}>
            <Loading
              type="spinningBubbles"
              color="#FFF"
              width={64}
              height={64}
            />
          </div>
        ) : (
          <>
            <img src={imageSuccess} alt="" />
            <h1>
              {isCounter
                ? `Seu pedido #${order.split(":")[0]} foi gerado com sucesso`
                : "Conta paga com sucesso!"}
            </h1>
            <ErroEmissaoNota show={showErroNotaFiscal} />
            <InformacaoClienteCompra
              customer={{
                id: 0,
                name: localStorage.getItem("customerName") || "Cliente",
                cpf: "",
                telephone: "",
                acceptTermDate: new Date(),
              }}
            />
            <Products produtos={products} />
            <NotaFiscal
              config={config}
              dataToNEF={dataToNEF}
              success={successNotaFiscal}
              show={showNotaFiscal}
            />
            <button
              style={{
                background: config?.webappcolor.webappbutton
                  ? config.webappcolor.webappbutton
                  : "#EAEAEA",
                color: config?.webappcolor.fontbutton
                  ? config.webappcolor.fontbutton
                  : "#636363",
              }}
              onClick={navigateToMenu}
            >
              {" "}
              <span> Acessar o cardápio novamente </span>
            </button>
          </>
        )}
      </div>
    </div>
  );
};

type InformacaoClienteCompraProps = {
  customer: CustomerType;
};

const InformacaoClienteCompra: FC<InformacaoClienteCompraProps> = ({
  customer,
}) => {
  const { getThisPluginspace, getToken } = usePluginspace();
  const [pluginspaceName, setPluginspaceName] = useState<string>();
  const { getType } = useOrder();
  const [hasPluginSpaceData, setHasPluginSpaceData] = useState<boolean>(false);
  const [type, setType] = useState("");
  const [location, setLocation] = useState("");
  async function findLocation(type: string) {
    return await api
      .get(`/api/location`, {
        headers: {
          Authorization: `Bearer ${await getToken()}`,
        },
      })
      .then(async (response) => {
        const location = response.data.data.find(
          (location: any) => location.code == type
        );
        return location ? location.name : "Entrega";
      })
      .catch((err) => {
        console.log(err);
        return "Entrega";
      });
  }

  async function loadPluginspaceData() {
    const pluginspaceData: any = await getThisPluginspace();
    const typeStorage = await getType();
    setLocation(await findLocation(typeStorage));

    if (pluginspaceData) {
      setPluginspaceName(pluginspaceData.name);
      setHasPluginSpaceData(true);
    }

    setType(typeStorage);
  }

  const {
    isInternalDelivery,
    isCard,
    isTable,
    tableNumber,
    cardNumber,
  } = useFoodConfig();

  function chooseModality() {
    switch (type) {
      case "withdraw":
        return "Retirada";
      case "delivery":
        return "Entrega";
      case "table":
        // ✅ MOSTRAR NÚMERO DA MESA
        if (isTable && tableNumber) {
          return `Mesa - ${tableNumber}`;
        }
        return "Mesa";
      case "card":
        if (isCard && cardNumber) {
          return `Comanda - ${cardNumber}`;
        }
        return "Comanda";
      case "counter":
        return "Retirada Balcão";
      case "synkar":
        const landmark = localStorage.getItem("landmark_synkar");
        if (
          landmark &&
          window.atob(landmark) &&
          JSON.parse(window.atob(landmark))
        ) {
          const landmarkItem = JSON.parse(window.atob(landmark));
          return `${location ? `${location} - ` : ""}${landmarkItem.landmark}`;
        } else return "Entrega";
      case "internal-delivery":
        const internalDeliveryNumber = localStorage.getItem("internal_number");
        const internalDeliveryName = localStorage.getItem("internal_name");
        if (internalDeliveryNumber && internalDeliveryName)
          return `Entrega - ${window.atob(internalDeliveryName)} ${window.atob(
            internalDeliveryNumber
          )}`;
        else return "Entrega Interna";
      default:
        return "Retirada";
    }
  }

  useEffect(() => {
    loadPluginspaceData();
  }, []);

  return (
    <div className={styles.customer}>
      <h4>Informações do Cliente</h4>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <span>
          <b>Cliente:</b> {customer.name}
        </span>
        {hasPluginSpaceData && (
          <>
            <span>
              <b>Loja:</b> {pluginspaceName}
            </span>
          </>
        )}

        {!isInternalDelivery && (
          <span>
            <b>Modalidade: </b>
            {chooseModality()}
          </span>
        )}
      </div>
    </div>
  );
};

type ErroNotaFiscalProps = {
  show: boolean;
};

const ErroEmissaoNota: FC<ErroNotaFiscalProps> = ({ show }) => {
  return (
    <>
      {show && (
        <div className={styles.erro_emicao}>
          <div>
            <h4>Nota fiscal não emitida</h4>

            <span>
              O pagamento foi confirmado, mas houve um problema ao emitir a sua
              nota fiscal. Entre em contato com a equipe do restaurante.
            </span>
          </div>
        </div>
      )}
    </>
  );
};

type NotaFiscalProps = {
  show: boolean;
  success: boolean;
  dataToNEF: {
    aggregateId: string;
    hostName: string;
  };
  config: any;
};

const NotaFiscal: FC<NotaFiscalProps> = ({
  show,
  dataToNEF,
  success,
  config,
}) => {
  const [email, setEmail] = useState("");
  const { getToken } = usePluginspace();
  const [loadingEmail, setLoadingEmail] = useState(false);
  const [data, setData] = useState("");
  const [hasNotaFiscal, setHasNotaFiscal] = useState(false);
  const [qrCode, setQrcode] = useState("");
  const loadXml = () => {
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(data, "application/xml");

    // Função para extrair as informações relevantes
    const extractInfo = () => {
      const nf = xmlDoc.querySelector("NFe > infNFe");
      if (!nf) return null;

      const ide = nf.querySelector("ide");
      const emit = nf.querySelector("emit");

      if (!ide) return null;
      if (!emit) return null;

      const enderEmit = emit.querySelector("enderEmit");
      const total = nf.querySelector("total > ICMSTot");

      // Extrair dados relevantes
      const dataEmissao = ide?.querySelector("dhEmi")?.textContent as string; // Data de Emissão
      const numeroNota = ide?.querySelector("chNFe")?.textContent; // Número da NF
      const nomeEstabelecimento = emit?.querySelector("xNome")?.textContent; // Nome do Estabelecimento
      const enderecoEstabelecimento =
        enderEmit?.querySelector("xLgr")?.textContent; // Logradouro do Estabelecimento
      const numeroEstabelecimento =
        enderEmit?.querySelector("nro")?.textContent; // Número do Estabelecimento
      const bairroEstabelecimento =
        enderEmit?.querySelector("xBairro")?.textContent; // Bairro
      const cidadeEstabelecimento =
        enderEmit?.querySelector("xMun")?.textContent; // Cidade
      const ufEstabelecimento = enderEmit?.querySelector("UF")?.textContent; // Estado
      const cepEstabelecimento = enderEmit?.querySelector("CEP")?.textContent; // CEP

      // Valor total
      const valorTotal = total?.querySelector("vNF")?.textContent;

      return {
        dataEmissao,
        numeroNota,
        nomeEstabelecimento,
        enderecoEstabelecimento,
        numeroEstabelecimento,
        bairroEstabelecimento,
        cidadeEstabelecimento,
        ufEstabelecimento,
        cepEstabelecimento,
        valorTotal,
      };
    };

    // Extraindo as informações
    const extractedInfo = extractInfo();
    if (!extractedInfo) return "";

    const {
      dataEmissao,
      numeroNota,
      nomeEstabelecimento,
      enderecoEstabelecimento,
      numeroEstabelecimento,
      bairroEstabelecimento,
      cidadeEstabelecimento,
      ufEstabelecimento,
      cepEstabelecimento,
      valorTotal,
    } = extractedInfo;

    // Formatando a data e hora de emissão
    const formattedDataEmissao = new Date(dataEmissao).toLocaleString("pt-BR");

    // Retornando os dados no formato solicitado
    return `
					<div  
							style="
								display: flex;
								flex-direction: column;
								gap: 16px;
								text-align: center;
								font-size: 12px;
								line-height: 18px;
						">
						<div style="
								display: flex;
								flex-direction: column;
								gap: 4px;
								text-align: center;
								font-size: 12px;
								line-height: 18px;
						">
							<span>${nomeEstabelecimento}</span>
							<span>${enderecoEstabelecimento}, ${numeroEstabelecimento}</span>
							<span>${bairroEstabelecimento} - ${cidadeEstabelecimento} - ${ufEstabelecimento}</span>
							<span>${cepToMask(cepEstabelecimento!)}</span>
						</div>
						<div style="
								display: flex;
								flex-direction: column;
								gap: 4px;
								text-align: center;
								font-size: 12px;
								line-height: 18px;
								padding: 20px 0px;
								border: #000000;
								border-top-style: dashed;
								border-bottom-style: dashed;
								border-top-width: thin;
								border-bottom-width: thin;
						"> 
							<span> Pagamento realizado com sucesso.</span>
							<span> Consulte sua nota fiscal pela chave abaixo </span>
							<span>${numeroNota}</span>
						</div>
						<div style="
								display: flex;
								flex-direction: column;
								gap: 4px;
								text-align: center;
								font-size: 12px;
								line-height: 18px;
						">
							<span>Data  ${formattedDataEmissao} </span>
							<span>Valor total: R$ ${valorTotal}</span>
						</div>
				</div>
		`;
  };

  const toastComponent = useToast();

  async function sendEmail() {
    try {
      if (!email || !email.includes("@")) {
        toastComponent.openToast(
          "warning",
          "Por favor, informe um email válido"
        );

        return;
      }
      setLoadingEmail(true);
      await api
        .post(
          "/api/email/send_email_nfiscal",
          {
            email: email,
            xml: data,
          },
          {
            headers: {
              Authorization: `Bearer ${await getToken()}`,
            },
          }
        )
        .then((response: any) => {
          toastComponent.openToast(
            "success",
            "Nota fiscal enviada com sucesso"
          );
          setLoadingEmail(false);
        })
        .catch((error: any) => {
          toastComponent.openToast(
            "warning",
            "Não foi possível enviar a nota fiscal. Por favor, tente novamente ou contacte o gerente da loja"
          );
          setLoadingEmail(false);
        });
    } catch (error) { }
  }

  async function getNotaFiscal() {
    try {
      setLoadingEmail(true);

      await api
        .post("/api/order-food/nfe_order_food", dataToNEF, {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        })
        .then((response: any) => {
          if (response.data) {
            const { xmlVenda, qrCode } = response.data.data;
            setData(xmlVenda);
            setQrcode(qrCode);
            setHasNotaFiscal(true);
            setLoadingEmail(false);
          }
        })
        .catch((error: any) => {
          if (error.response.data) {
            const { msg, success } = error.response.data;
            toastComponent.openToast(
              "warning",
              "Não foi possível recuperar a nota fiscal. Por favor, tente novamente ou contacte o gerente da loja",
              5000
            );
            setLoadingEmail(false);
            return;
          }
        });
    } catch (error) {
      toastComponent.openToast(
        "warning",
        "Não foi possível recuperar a nota fiscal. Por favor, tente novamente ou contacte o gerente da loja",
        5000
      );
      setLoadingEmail(false);
    }
  }

  return (
    <>
      {show && (
        <div className={styles.nota_fiscal}>
          <h4>Nota fiscal</h4>
          {!success ? (
            <>
              <span className={styles.nota_fiscal_text}>
                Não foi possível imprimir a sua nota fiscal. Por favor dirija-se
                ao caixa para solicitar a impressão.{" "}
              </span>
            </>
          ) : (
            <>
              {!hasNotaFiscal ? (
                <>
                  <span className={styles.nota_fiscal_text}>
                    Sua nota fiscal foi Emitida, deseja visualiza-la?
                  </span>

                  <button
                    onClick={getNotaFiscal}
                    style={{
                      background: config?.webappcolor.webappbutton
                        ? config.webappcolor.webappbutton
                        : "#EAEAEA",
                      color: config?.webappcolor.fontbutton
                        ? config.webappcolor.fontbutton
                        : "#636363",
                    }}
                  >
                    {" "}
                    <span>
                      Receber nota fiscal{" "}
                      {loadingEmail && (
                        <ReactLoading
                          type={"spin"}
                          color={"#FFFFFF"}
                          height={"25px"}
                          width={"25px"}
                        />
                      )}{" "}
                    </span>
                  </button>
                </>
              ) : (
                <>
                  <span className={styles.nota_fiscal_text}>
                    Aqui está a sua nota fiscal.
                  </span>

                  {data && (
                    <div
                      dangerouslySetInnerHTML={{ __html: loadXml() }}
                      style={{
                        background: "rgba(255, 252, 239, 1)",
                        padding: "8px",
                        width: "100%",
                        boxSizing: "border-box",
                      }}
                    />
                  )}

                  <div className={styles.email_send}>
                    <Input
                      inputAttr={{
                        type: "email",
                      }}
                      name="email"
                      label={`Para receber a nota fiscal completa por favor informe o seu email`}
                      placeholder="email@email.com"
                      value={email}
                      change={(value: string) => {
                        setEmail(value);
                      }}
                    />
                    <button
                      onClick={sendEmail}
                      style={{
                        background: config?.webappcolor.webappbutton
                          ? config.webappcolor.webappbutton
                          : "#EAEAEA",
                        color: config?.webappcolor.fontbutton
                          ? config.webappcolor.fontbutton
                          : "#636363",
                      }}
                    >
                      {" "}
                      <span>
                        Receber nota fiscal{" "}
                        {loadingEmail && (
                          <ReactLoading
                            type={"spin"}
                            color={"#FFFFFF"}
                            height={"25px"}
                            width={"25px"}
                          />
                        )}{" "}
                      </span>
                    </button>

                    {qrCode && (
                      <button
                        onClick={() => window.open(qrCode, "_blank")}
                        style={{
                          background: "#008F39",
                          color: config?.webappcolor.fontbutton
                            ? config.webappcolor.fontbutton
                            : "#636363",
                          marginTop: "8px",
                        }}
                      >
                        {" "}
                        <span>Ver minha nota fiscal</span>
                      </button>
                    )}
                  </div>
                </>
              )}
            </>
          )}
        </div>
      )}
    </>
  );
};
type ProductsProps = {
  produtos: any;
};
const Products: FC<ProductsProps> = ({ produtos }: any) => {
  const { organizeFractions } = useProduct();
  return (
    <div className={styles.produtcs}>
      <h4>Produtos</h4>
      {produtos.length > 0 &&
        produtos.map((product: any) => {
          let priceAdditionals = 0;
          if (product.additionals) {
            let tempPrice = 0;
            product.additionals.map(
              (additional: any) =>
                (tempPrice += additional.quantity * additional.price)
            );
            priceAdditionals = tempPrice;
          }
          return (
            <div
              className="finalize-order-details"
              style={{
                marginTop: "0px !important",
              }}
              key={product.id}
            >
              <div className="product">
                <div className="product-image">
                  {product.image ? (
                    <ImageLazy name={product.name} image={product.image} />
                  ) : (
                    <div className="no-image" />
                  )}
                </div>
                <div className="product-infos">
                  <p>{product.name}</p>
                  {Object.entries(product.variation).map((variation, index) => {
                    if (
                      variation[0] !== "VARIATION" &&
                      variation[1] !== "NONE"
                    ) {
                      return (
                        <p className="variation" key={index}>
                          {variation[0] === "NOME_COR" ? "COR" : variation[0]}:{" "}
                          <b>{variation[1]}</b>
                        </p>
                      );
                    }
                  })}
                  {product.additionals && (
                   <div style={{ maxHeight: "4rem", overflowY: "auto" }}>
                      {product.additionals.map((additional: any, i: number) => (
                        <p
                          className="additional"
                          key={`additional-${i}`}
                        >{`${additional.quantity}x ${additional.name
                          } (${floatToPrice(additional.price)})`}</p>
                      ))}
                    </div>
                  )}
                  {product.fractions && (
                   <div style={{ maxHeight: "4rem", overflowY: "auto" }}>
                      {organizeFractions(product.fractions).map((fractional, i) => (
                        <p
                          className="additional"
                          key={`fractional-${i}`}
                        >{`${fractional.quantity}/${product.fractions?.length
                          } ${fractional.name} (${floatToPrice(
                            fractional.price,
                          )})`}</p>
                      ))}
                    </div>
                  )}
                  {product.unitPrice === product.promotionalPrice ||
                    product.promotionalPrice === 0 ? (
                    <div className="product-values">
                      <div className="values">
                        <p className="promotional">-R$ 0</p>
                        <p>
                          {product.type === "fractional"
                            ? floatToPrice(
                              calculatePriceFractionalToProduct(product) *
                              product.quantity +
                              priceAdditionals * product.quantity
                            )
                            : floatToPrice(
                              product.unitPrice * product.quantity +
                              priceAdditionals * product.quantity
                            )}
                        </p>
                        <p>Quantidade: {product.quantity}</p>
                      </div>
                    </div>
                  ) : (
                    <div className="product-values">
                      <div className="values">
                        <p className="promotional">
                          -
                          {floatToPrice(
                            product.quantity *
                            (product.unitPrice - product.promotionalPrice)
                          )}
                        </p>
                        <p>
                          {floatToPrice(
                            product.quantity * product.promotionalPrice
                          )}
                        </p>
                        <p>Quantidade: {product.quantity}</p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          );
        })}
    </div>
  );
};

export { SuccessOrderFood };
